import { apiFirebase } from "api"
import { uuid } from "uuidv4"

export function renderStatus({ status, match_time, pen_score, time_status }) {
  let text = time_status || ""
  let __class = ""
  if (status === 0) {
    const date = new Date(match_time * 1000)
    text = date.getHours() + ":" + addZero(date.getMinutes())
  }
  if (status === 1 || status === 3) {
    __class = "text-orange-400 font-bold"
  }
  if (status === 5) {
    text = "PEN" + pen_score
    __class = "text-orange-400 font-bold"
  }
  if (status === -11) text = "TBD"
  return { text, class: __class }
}

function addZero(i) {
  return i < 10 ? "0" + i : i
}

export function numberToPhone(text) {
  if (text) return text.toString().replace(/(\d{4})(\d{3})(\d{3})/, "$1.$2.$3")
}
export function numberToCurrency(number) {
  if (number) {
    return parseInt(number)
      .toString()
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
  }
  return 0
}

export function getDeviceIdFromLocal() {
  let device_id = localStorage.getItem("device_id")
  if (!device_id) {
    device_id = uuid()
    localStorage.setItem("device_id", device_id)
  }
  return device_id
}

export function trackGA(title, type) {
  if (window?.gtag) {
    window.gtag("event", "page_view", {
      content_type: type,
      content_group: type,
      content: title,
      item_name: title
    })
  }
}

export function convertTypeVideo(number) {
  if (number === 1) return "EVENT_VIDEO"
  if (number === 2) return "VOD_VIDEO"
  return "N/A"
}

export function convertTypeVideoDetail(number) {
  if (number === 1) return "MatchesEventVC"
  if (number === 2) return "VODDetailVC"
  return "N/A"
}
export function FormatDate(value) {
  const dateString = value
  const date = new Date(dateString)

  const day = date.getDate().toString().padStart(2, "0")
  const month = (date.getMonth() + 1).toString().padStart(2, "0")
  const year = date.getFullYear().toString()

  const formattedDate = `${day}/${month}/${year}`
  return formattedDate
}

export function formatPhoneNumberHiddenNumber(phone) {
  if (!phone) return ""
  let rawValue = phone.replace(/[^\d]/g, "").slice(0, 10)

  return rawValue.replace(/(\d{4})(\d{3})?(\d{3})?/, (match, p1, p2, p3) => {
    let result = p1
    if (p2) result += " xxx"
    if (p3) result += " " + p3
    return result
  })
}

export const formatPhoneNumber = (phone) => {
  if (!phone || typeof phone !== "string") return phone

  let digits = phone.replace(/\D/g, "")

  if (digits.startsWith("84")) {
    digits = "0" + digits.slice(2)
  }
  if (digits.length !== 10) return phone

  return digits.replace(/(\d{4})(\d{3})(\d{3})/, "$1 $2 $3")
}

export async function sendTokenFirebase(body) {
  try {
    await apiFirebase.createTokenFirebase(body)
  } catch (error) {
    console.log(error)
  }
}

export function getCookieValue(name) {
  const nameEQ = name + "="
  const cookies = document.cookie.split(";")
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i]
    while (cookie.charAt(0) === " ") cookie = cookie.substring(1, cookie.length)
    if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length, cookie.length)
  }
  return null
}

export const getMobileOperatingSystem = () => {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone"
  }

  if (/android/i.test(userAgent)) {
    return "Android"
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS"
  }

  return "unknown"
}

export const hex2rgba = (hex, alpha = 1) => {
  const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16))
  return `rgba(${r},${g},${b},${alpha})`
}
